import KeenSlider from './KeenSlider';

export default KeenSlider;
